module.exports = __webpack_public_path__ + "img/app_play.60524daa.png";